import { io } from 'socket.io-client';

export const socketConfig = io(process.env.REACT_APP_API_WEBSOCKET as string, {
  autoConnect: false,
  multiplex: false,
  transports: ['websocket'],
});
